export default __webpack_public_path__ + "static/caliscale-presentation-b8ac150cf1196ec4feca0b6984073d4e.mp4";